import { OrganizationSettings } from '@care-portals/api-interfaces';
import { CRM_WEB_PAGES_URLS } from '../../CRM_WEB_PAGES_URLS';
import { ADMIN_WEB_PAGES_URLS } from '../../EMR_WEB_PAGES_URLS';
import { PATIENT_WEB_PAGES_URLS } from '../../PATIENT_WEB_PAGES_URLS';
import { caProvinces } from '../../data';

const provinces = [...caProvinces, { code: 'other', province: 'Other' }];

export const momwell_ca_digital: OrganizationSettings = {
  name: 'Momwell',
  fromEmail: 'hello@momwell.com',
  replyToEmail: 'hello@momwell.com',
  forgotPasswordTemplateId: '646ae940fd3d60df26ac1265',
  verifyAccountTemplateId: '646e3623d73c41f038464387',
  ecommerceEnabled: true,
  stripeEnabled: true,
  conversationServiceId: 'IS9d8b15500b914f3a98bff0a083e18592',
  mainStripeOrg: 'momwell_digital',
  currency: 'cad',
  patientPortalDomain: 'momwell-ca-digital.portals.care',
  crmWebAppLayout: {
    title: 'Momwell CA Digital',
    icon: 'https://uploads-ssl.webflow.com/630cf5c3fde88d3fa5008ecc/64e7b973bdcebab0ff0d4f17_icon-momwell.svg?ssl=1',
    // logo: 'https://jack.health/wp-content/uploads/Jack-Logo.svg',
    locations: provinces.map(s => ({ value: s.code, label: s.province })),
    mainMenu: [
      {
        title: 'Appointments',
        link: CRM_WEB_PAGES_URLS.appointments.calendar,
        icon: 'fa-regular fa-calendar-check',
        roles: ['*']
      },
      {
        title: 'Leads',
        link: CRM_WEB_PAGES_URLS.leads.list,
        icon: 'fa-regular fa-address-book',
        roles: ['*']
      },
      {
        title: 'Tasks',
        link: CRM_WEB_PAGES_URLS.tasks.list,
        icon: 'fa-solid fa-list-check',
        roles: ['*']
      },
      {
        title: 'Segments',
        link: CRM_WEB_PAGES_URLS.segment.list,
        icon: 'fa-solid fa-table-columns',
        roles: ['*']
      },
      {
        title: 'Store Manager',
        link: '',
        icon: 'fas fa-shop',
        roles: ['admin', 'developer', 'owner'],
        items: [
          {
            title: 'Products',
            link: CRM_WEB_PAGES_URLS.products.list,
            icon: 'fas fa-product'
          },
          {
            title: 'Coupons',
            link: CRM_WEB_PAGES_URLS.coupons.list,
            icon: 'fas fa-gift'
          },
          {
            title: 'Promotions',
            link: CRM_WEB_PAGES_URLS.promotions.list,
            icon: 'fas fa-gift'
          }
        ]
      },
      {
        title: 'Admin',
        link: '',
        icon: 'fas fa-user-cog',
        roles: ['owner', 'admin', 'developer'],
        items: [
          {
            title: 'Services',
            link: CRM_WEB_PAGES_URLS.services.list,
            icon: 'fas fa-medkit'
          },
          {
            title: 'Schedules',
            link: CRM_WEB_PAGES_URLS.schedules.list,
            icon: 'fas fa-calendar'
          },
          {
            title: 'Users',
            link: CRM_WEB_PAGES_URLS.users.list,
            icon: 'fas fa-lock'
          },
          {
            title: 'Forms',
            link: CRM_WEB_PAGES_URLS.forms.list,
            icon: 'fas fa-table'
          },
          {
            title: 'Workflows',
            link: CRM_WEB_PAGES_URLS.workflows.list,
            icon: 'fas fa-code-branch'
          },
          {
            title: 'Templates',
            link: CRM_WEB_PAGES_URLS.emailTemplates.list,
            icon: 'fas fa-palette'
          },
          {
            title: 'Settings',
            link: CRM_WEB_PAGES_URLS.settings.base,
            icon: 'fa-solid fa-sliders'
          }
        ]
      }
    ]
  },
  emrWebAppLayout: {
    title: 'Momwell CA Digital',
    defaultPingMsg:
      '🛎️ Ping! Momwell care team is waiting for your response. To respond, please go to https://momwell.portals.care/messages',
    mainMenu: [
      {
        title: 'Patients',
        name: 'patients',
        link: ADMIN_WEB_PAGES_URLS.customers.allList,
        icon: 'fas fa-user-injured',
        roles: ['*']
      },
      {
        title: 'Appointments',
        link: ADMIN_WEB_PAGES_URLS.appointments.calendar,
        icon: 'fas fa-calendar-check',
        roles: ['*']
      },
      {
        title: 'Purchases',
        name: 'purchases',
        link: ADMIN_WEB_PAGES_URLS.orders.allList,
        icon: 'fas fa-shopping-cart',
        roles: ['admin', 'owner', 'user']
      }
    ],
    customerTabs: [
      'consults',
      'appointments',
      'orders',
      'invoices',
      'notes',
      'files',
      'payment-methods',
      'coupons'
    ],
    questionnaires: [
      'epds',
      'phq9',
      'gad7',
      'dass21',
      'pcl5',
      'bms_before',
      'bms_after'
    ]
  },
  patientWebAppLayout: {
    title: 'Momwell',
    brand: 'momwell',
    shopUrl: 'https://www.momwell.com/shop',
    topAction: {
      title: 'Book Now',
      link: 'https://momwell.com/booking?email=${email}'
    },
    logo: {
      img: 'https://uploads-ssl.webflow.com/640f9228c4417a7d888139b2/64818f81ceb27827150a4c8b_Momwell%20CA.svg',
      link: 'https://momwell.com'
    },
    referrals: {
      enabled: false,
      referrerAmount: 50,
      refereeAmount: 30,
      referralURI: 'https://momwell-ca.portals.care/auth/signup',
      referralFAQ: 'https://www.momwell.com/referral-rewards/'
    },
    privacyPolicyUrl: 'https://www.momwell.com/privacy-policy',
    termsOfUseUrl: 'https://www.momwell.com/terms-of-use',
    stripePublicKey:
      'pk_live_51Ojo9mAKkDdpt04aPyonqqyVVnKKchn6aYLpIc1GE0QCCzBUE1OR6MLSDxOat5djEg6VnKEOgTRfr3aTVKtRwAz700uRnTOCax',
    mainMenu: [
      {
        title: 'Appointments',
        type: 'external',
        link:
          'https://momwell.com/login?redirectTo=' +
          PATIENT_WEB_PAGES_URLS.account.appointments,
        svg: 'https://uploads-ssl.webflow.com/640f9228c4417a7d888139b2/647394bf1b9079853dd9b9d9_appointments.svg',
        roles: ['*']
      },
      {
        title: 'Workshops & Courses',
        link: PATIENT_WEB_PAGES_URLS.account.workshops,
        svg: 'https://uploads-ssl.webflow.com/640f9228c4417a7d888139b2/647394bfc2cbcbab683e36ae_courses.svg',
        roles: ['*']
      },
      {
        title: 'Forms',
        link: PATIENT_WEB_PAGES_URLS.account.questionnaires,
        svg: 'https://uploads-ssl.webflow.com/640f9228c4417a7d888139b2/6474fa78506b37e70b798189_Form.svg',
        roles: ['*']
      },
      {
        title: 'Billing',
        link: 'billing',
        svg: 'https://uploads-ssl.webflow.com/640f9228c4417a7d888139b2/647394bf1599f3a16bdf2b6a_billing.svg',
        type: 'external',
        roles: ['*']
      }
    ],
    availableStates: {
      ca: provinces
    }
  }
};
